import React from "react";
import AllWithdrawals from "../../components/Withdrawals/AllWithdrawals";

function Withdrawals() {
  return (
    <div>
      <AllWithdrawals />
    </div>
  );
}

export default Withdrawals;